import { PLUS, PREMIER, STANDARD, WC_COMP } from 'constants/classOfService';
import {
  DISALLOWED_CLASSES,
  INVENTORY_CLASSES,
  KL,
  NEW_CLASS_OF_SERVICE_MAP_NAMES,
  OLD_CLASS_OF_SERVICE_MAP_NAMES
} from 'constants/inventoryClass';

export const getInventoryClassByCode = (code) => Object.keys(INVENTORY_CLASSES).find((inventoryClass) => code?.startsWith(inventoryClass));

export const hasSameInventoryClass = (currentInventoryClasses, carriageInventoryClass) =>
  carriageInventoryClass
    .filter((inventoryClass) => inventoryClass !== KL)
    .some((inventoryClass) => currentInventoryClasses.includes(inventoryClass));

export const getAllowedInventoryClasses = (inventoryClasses) =>
  inventoryClasses.filter((inventoryClass) => inventoryClass && !DISALLOWED_CLASSES.has(inventoryClass));

export const getClassOfServiceMapNameByInventoryClass = (inventoryClass, classOfService, showNewTrainMapName = false) => {
  if (!classOfService || [STANDARD, PLUS, PREMIER].includes(classOfService) || (classOfService === WC_COMP && showNewTrainMapName)) {
    return NEW_CLASS_OF_SERVICE_MAP_NAMES[inventoryClass];
  }

  return OLD_CLASS_OF_SERVICE_MAP_NAMES[inventoryClass];
};
